<ng-template #toastTemplate let-toast>
    <app-toast-base [toastRef]="toast" [iconUrl]="iconUrl">
        {{message | translate}}
    </app-toast-base>
</ng-template>
